export default __webpack_public_path__ + "static/link-label-do-f66913fc0e35ccd3ba01268f35de95dd.png";